import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import ScreenHeader from "../ScreenHeader";
import PropTypes from "prop-types";
import TrashIcon from "../../assets/icons/Trash-16px-Red-60.svg";
import PlusIcon from "../../assets/icons/Plus-Enabled-16px-Blue-60.svg";
import { isValidEmail } from "../../util/validity-helpers";
import "./InviteTeam.scss";

const Email = (props) => {
    const { id, value, onChange, onRemove, validate } = props;
    return (
        <Row className="invite-team-email">
            <Col>
                <Form.Group noValidate validated={validate}>
                    <Form.Label>Email address</Form.Label>
                    <Form.Control className="email-input input"
                        type="text"
                        as="input"
                        value={value}
                        placeholder="example@triyosoft.com"
                        onChange={(e) => onChange(e.target.value, id)}
                        isInvalid={(!isValidEmail(value) && (value.length>0 || validate))}
                        required
                        autoComplete="off"
                    />
                    <Form.Control.Feedback type="invalid">
                        Please provide a valid email address.
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col sm="1" xs="1" md="1" lg="1">
                <Image className="icon-image-delete"
                    onClick={() => onRemove(id)}
                    src={TrashIcon}
                    alt="Delete email address"
                />
            </Col>
        </Row>
    );
}

const InviteTeam = ({ firstName, validate, onValidate, emails }) => {
    const [emailsSelection, setEmailsSelection] = useState(emails? emails : [""]);

    const onChange = (value, id) => {
        let tempState = [...emailsSelection];
        tempState[id] = value;
        setEmailsSelection(tempState);
    }

    const onRemove = (id) => {
        if (emailsSelection.length > 1) {
            setEmailsSelection(emailsSelection.filter((item, index) => index !== id));
        }
    }

    const onAdd = () => {
        if (emailsSelection.length < 5) {
            setEmailsSelection([
                ...emailsSelection,
                ""
            ])
        }
    }

    const validator = () => {
        let executeValidation=true;
        for (let item of emailsSelection) {
            if (!isValidEmail(item)) {
                executeValidation=false;
                break;
            }
        }
        return onValidate({
            isValid: executeValidation,
            emailsSelection
        })
    };

    useEffect(() => {
        validator();
    })

    return (
        <Container className="invite-team">
            <Row>
                <Col>
                    <ScreenHeader
                        heading={`${firstName}, who do you work with?`}
                        subHeading="Make the most of TRIYO by inviting up to five colleagues."
                    />
                    <div className="email-list-container">

                        <span>
                            {
                                emailsSelection.map((item, index) => {
                                    return (<Email id={index} value={item} onChange={onChange} onRemove={onRemove} validate={validate} />)
                                })
                            }
                        </span>

                        <Row>
                            <Col style={{ top: "-8px" }}>
                                <Button className="add-email-button" onClick={onAdd} disabled={emailsSelection.length === 5} >
                                    Add an Email<Image className="icon-image-add" data-mdb-ripple-color="light" src={PlusIcon} alt="Add an Email" />
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

InviteTeam.propTypes = {
    validate: PropTypes.bool.isRequired,
    firstName: PropTypes.string,
    onValidate: PropTypes.func.isRequired,
    emails: PropTypes.array
}

export default InviteTeam;